<template>
    <div>
      <banner
        title="Kebijakan"
        description="Daftar undang-undang, pemendikbud, dan keputusan menteri terkait Perbukuan."
        :breadcrumbs="breadcrumbs"
        :icon="require('@/assets/home/decoration/kebijakan.svg')"
        :compact="true"
      />
  
      <section id="content" class="mt-4">
        <div class="container">
          <div class="row">
            <div class="col-md-3">
              <div class="sidebar">
                <!-- Filter Kategori -->
                <div class="mb-4">
                  <h6 class="font-weight-bold mb-3 text-grey-700">Kategori Regulasi</h6>
                  <ul class="list-unstyled">
                    <li
                      v-for="filterOption in filterOptions"
                      :key="filterOption.value"
                      class="d-flex align-items-center mb-2 text-grey-500 p-2 rounded-lg"
                      style="cursor:pointer"
                      @click="filter = filterOption.value; pageNumber = 1"
                      :class="{
                        ' bg-grey-400/10': filterOption.value === filter,
                      }"
                    >
                      <svg-icon :name="`kebijakan-${filterOption.value.toLowerCase()}`"/>
                      <span class="pl-2">
                        {{ filterOption.label }}
                      </span>
                    </li>
                    <li role="button" @click.prevent="filter = 'Perka'; pageNumber = 1" class="mb-2 p-2 rounded-lg" style="cursor:pointer" :class="{'bg-grey-400/10': filter === 'Perka'}">
                      <div class="d-flex align-items-center">
                        <i class="fa-regular fa-fw fa-file-lines text-success"></i> 
                        <span class="pl-2">Peraturan Kepala Badan</span>
                      </div>
                    </li>
                    <li role="button" @click.prevent="filter = 'News'; pageNumber = 1" class="mb-2 p-2 rounded-lg" style="cursor:pointer" :class="{'bg-grey-400/10': filter === 'News'}">
                      <div class="d-flex align-items-center">
                        <i class="fas fa-fw fa-newspaper"></i> 
                        <span class="pl-2">Berita</span>
                      </div>
                    </li>
                    <li role="button" @click.prevent="filter = 'lainnya'; pageNumber = 1" class="mb-2 p-2 rounded-lg" style="cursor:pointer" :class="{'bg-grey-400/10': filter === 'lainnya'}">
                      <div class="d-flex align-items-center">
                        <i class="fas fa-fw fa-ellipsis-vertical"></i> 
                        <span class="pl-2">Lainnya</span>
                      </div>
                    </li>
                  </ul>
                </div>

                <!-- Filter Status -->
                <div class="mb-4 border-top pt-3">
                  <h6 class="font-weight-bold mb-3 text-grey-700">Status Berlaku</h6>
                  <ul class="list-unstyled">
                    <li role="button" @click.prevent="statusFilter = 'semua'; pageNumber = 1" class="mb-2 p-2 rounded-lg" style="cursor:pointer" :class="{'bg-grey-400/10': statusFilter === 'semua'}">
                      <div class="d-flex align-items-center">
                        <i class="fas fa-fw fa-check-double"></i>
                        <span class="pl-2">Semua Status</span>
                      </div>
                    </li>
                    <li role="button" @click.prevent="statusFilter = 'Berlaku'; pageNumber = 1" class="mb-2 p-2 rounded-lg" style="cursor:pointer" :class="{'bg-grey-400/10': statusFilter === 'Berlaku'}">
                      <div class="d-flex align-items-center">
                        <i class="fas fa-fw fa-file-circle-check text-success"></i> 
                        <span class="pl-2">Berlaku</span>
                      </div>
                    </li>
                    <li role="button" @click.prevent="statusFilter = 'Tidak Berlaku'; pageNumber = 1" class="mb-2 p-2 rounded-lg" style="cursor:pointer" :class="{'bg-grey-400/10': statusFilter === 'Tidak Berlaku'}">
                      <div class="d-flex align-items-center">
                        <i class="fas fa-fw fa-file-circle-xmark text-secondary"></i> 
                        <span class="pl-2">Tidak Berlaku</span>
                      </div>
                    </li>
                  </ul>
                </div>

                <!-- Filter Tahun -->
                <div class="mb-4 border-top pt-3">
                  <h6 class="font-weight-bold mb-3 text-grey-700">Tahun</h6>
                  <div class="mb-2">
                    <button 
                      @click="yearFilter = '2026'; pageNumber = 1"
                      :class="{'btn-year-active': yearFilter === '2026'}"
                      class="btn btn-sm btn-outline-primary btn-year mr-2"
                    >
                      2026
                    </button>
                    <button 
                      @click="yearFilter = '2025'; pageNumber = 1"
                      :class="{'btn-year-active': yearFilter === '2025'}"
                      class="btn btn-sm btn-outline-primary btn-year"
                    >
                      2025
                    </button>
                  </div>
                  <input 
                    v-model="yearFilter" 
                    @keyup="pageNumber = 1"
                    type="text" 
                    class="form-control form-control-sm" 
                    placeholder="Ketik tahun lain..."
                  />
                </div>

                <!-- Sort -->
                <div class="border-top pt-3">
                  <h6 class="font-weight-bold mb-3 text-grey-700">Urutan</h6>
                  <select v-model="sortBy" @change="pageNumber = 1" class="form-control form-control-sm">
                    <option value="terbaru">Terbaru</option>
                    <option value="terlama">Terlama</option>
                    <option value="a-z">A - Z</option>
                    <option value="z-a">Z - A</option>
                  </select>
                </div>
              </div>
            </div>
  
            <div class="col-md-9">
              <div v-if="$store.state.loadPage" class="loading text-center">
                <img src="@/assets/loading-2.gif" alt="" class="img-fluid" />
              </div>
              <template v-else>
                <div class="input-group mb-3" style="width: 300px;">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-transparent pr-2">
                      <i class="fa-solid fa-magnifying-glass"></i>
                    </span>
                  </div>
                  <input
                    v-model="keyword"
                    class="form-control pl-0 border-left-0"
                    placeholder="Cari kata kunci"
                  />
                </div>
                <div class="table-responsive border">
                  <table class="table table-condensed ">
                    <template
                      v-if="
                        filteredPolicies[0].category?.name == 'News' &&
                          filteredPolicies != ''
                      "
                    >
                      <tr class="thead-light">
                        <th>Informasi Berita</th>
                      </tr>
                      <tr
                        v-for="(policy, index) of splittedPolicies"
                        :key="index"
                      >
                        <td>
                          <a :href="policy.featured_image" target="_blank">{{
                            policy.title
                          }}</a>
                        </td>
                      </tr>
                    </template>
                    <template v-else-if="filteredPolicies != ''">
                      <tr class="thead-light">
                        <!-- <th></th> -->
                        <th>No</th>
                        <th>Jenis Regulasi</th>
                        <th>Nomor Regulasi</th>
                        <th>Judul Regulasi</th>
                        <th>Berlaku/Tidak Berlaku</th>
                        <th>Opsi</th>
                      </tr>
                      <tr
                        v-for="(policy, index) of splittedPolicies"
                        :key="index"
                      >
                        <!-- <td>
                          <svg-icon
                            :name="`kebijakan-${policy.category.slug}`"
                            :key="filter + keyword"
                          />
                        </td> -->
                        <td>{{ index + 1 }}</td>
                        <td>{{ policy.category?.name }}</td>
                        <td>{{ policy.sk_number }}</td>
                        <td>{{ policy.title }}</td>
                        <td>{{ policy.isvalid == '1' ? 'Berlaku' : 'Tidak Berlaku' }}</td>
                        <td width="75" class="text-center">
                          <div class="dropdown">
                            <i
                              class="fas fa-fw fa-ellipsis"
                              data-toggle="dropdown"
                              style="cursor:pointer"
                            />
                            <div
                              class="dropdown-menu"
                              style="border-radius:.5rem"
                            >
                              <a
                                @click="show(policy.featured_image)"
                                class="mr-2 btn-xs btn-read dropdown-item d-flex align-items-center"
                                data-url="https://static.cdn-cdpl.com/sibi/1097_AccMF_rekrutmen_calonpenilai_2021.pdf"
                                data-type="PDF"
                                href="#"
                              >
                                <div
                                  class="px-1 rounded-lg"
                                  style="background:#E8D6FF;"
                                >
                                  <svg-icon
                                    name="eye"
                                    style="width:1.2rem"
                                  ></svg-icon>
                                </div>
                                <span class="pl-2 text-grey-500">
                                  Lihat
                                </span>
                              </a>
                              <div class="dropdown-divider"></div>
                              <a
                                type="button"
                                :href="policy.featured_image"
                                target="_blank"
                                class="btn-xs mr-2 btn-push-statistic dropdown-item d-flex align-items-center"
                                data-id="8"
                                data-activity="download"
                              >
                                <div class="px-1 rounded-lg bg-primary-100/50">
                                  <svg-icon
                                    name="download"
                                    style="width:1.2rem"
                                  ></svg-icon>
                                </div>
                                <span class="pl-2 text-grey-500"> Unduh</span>
                              </a>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </template>
                    <tfoot>
                      <tr>
                        <td colspan="99">
                          <div
                            class="d-flex justify-content-between align-items-center"
                            v-if="filteredPolicies.length"
                          >
                            <span>
                              Menampilkan {{ perPage }} dari
                              {{ filteredPolicies.length }} hasil
                            </span>
                            <pagination
                              class="m-0"
                              :current-page="pageNumber"
                              :total-data="filteredPolicies.length"
                              :total-page="totalPage"
                              :key="totalPage"
                              :max-page="3"
                              @change="onChangePage"
                            />
                          </div>
                          <div v-else class="text-center">
                            Data tidak ditemukan
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </template>
  
              <div class="row">
                <div class="col-lg-12">
                  <nav class="courses-pagination mt-50">
                    <div class="row my-4 text-right">
                      <div class="col-md-12">
                        <nav id="pagination">
                          <!-- <strong>1</strong
                          ><a
                            href="http://sibi.local/kebijakan/2"
                            data-ci-pagination-page="2"
                            >2</a
                          ><a
                            href="http://sibi.local/kebijakan/2"
                            data-ci-pagination-page="2"
                            rel="next"
                            >&gt;</a
                          > -->
                        </nav>
                        <!-- courses pagination -->
                      </div>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  
      <div class="modal" id="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Kebijakan</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <embed
                id="embed"
                type="application/pdf"
                width="100%"
                height="400px"
              />
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <style scoped>
  .sidebar {
    border: 1px solid #dbddf0;
    border-radius: 0.5rem;
    padding: 1rem;
  }

  .sidebar h6 {
    font-size: 0.875rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .sidebar ul li {
    transition: all 0.2s ease;
  }

  .sidebar ul li:hover {
    background-color: rgba(219, 221, 240, 0.3) !important;
  }

  .form-control-sm {
    border-color: #dbddf0;
    border-radius: 0.5rem;
    font-size: 0.875rem;
  }

  .form-control-sm:focus {
    border-color: #7c3aed;
    box-shadow: 0 0 0 0.2rem rgba(124, 58, 237, 0.1);
  }

  .table thead th {
    font-weight: 600;
    border-bottom: 2px solid #e5e7eb;
  }

  .text-grey-700 {
    color: #374151;
  }

  .text-grey-500 {
    color: #6b7280;
  }

  .btn-year {
    font-size: 0.875rem;
    padding: 0.375rem 0.75rem;
  }

  .btn-year-active {
    background-color: #7c3aed !important;
    border-color: #7c3aed !important;
    color: white !important;
  }
  </style>
  <script>
  import $ from "jquery";
  import { mapActions, mapState } from "vuex";
  import SvgIcon from "../../components/common/SvgIcon.vue";
  import Banner from "../../components/homepage/Banner.vue";
  import Pagination from "../../components/common/Pagination.vue";
  export default {
    components: { SvgIcon, Banner, Pagination },
    watch: {
      filter() {
        this.pageNumber = 1;
      },
      keyword() {
        this.pageNumber = 1;
      },
    },
    data() {
      return {
        breadcrumbs: [
          {
            label: "Beranda",
            url: "/",
          },
          {
            label: "Kebijakan",
            url: "",
          },
        ],
        keyword: "",
        type: {
          undangUndang: "",
          permen: "",
        },
        filter: "semua",
        statusFilter: "semua",
        yearFilter: "",
        sortBy: "terbaru",
        filterOptions: [
          {
            label: "Semua",
            value: "semua",
          },
          {
            label: "Undang-undang",
            value: "Undang-undang",
          },
          {
            label: "Peraturan Pemerintah",
            value: "PP",
          },
          {
            label: "Peraturan Menteri",
            value: "Permen",
          },
          {
            label: "Keputusan Menteri",
            value: "Kepmen",
          },
          {
            label: "Surat Keputusan",
            value: "SK",
          },
        ],
        perPage: 10,
        pageNumber: 1,
      };
    },
    computed: {
      ...mapState(["policies"]),
      filteredPolicies() {
        let data = this.policies;

        // Filter berdasarkan kategori
        if (this.filter === "Berlaku") {
          data = data.filter((policy) => policy.isvalid == '1');
        } else if (this.filter === "Tidak Berlaku") {
          data = data.filter(policy => policy.isvalid == '0');
        } else if (this.filter !== "semua") {
          data = this.filteredType;
        } else if (this.filter === "semua") {
          data = this.policies.filter(
            (policy) => policy.category?.name !== "News"
          );
        }

        // Filter berdasarkan status berlaku/tidak berlaku
        if (this.statusFilter === "Berlaku") {
          data = data.filter((policy) => policy.isvalid == '1');
        } else if (this.statusFilter === "Tidak Berlaku") {
          data = data.filter((policy) => policy.isvalid == '0');
        }

        // Filter berdasarkan tahun (cari di Nomor Regulasi/sk_number)
        if (this.yearFilter) {
          data = data.filter((policy) => {
            return policy.sk_number && 
                   policy.sk_number.toLowerCase().includes(this.yearFilter.toLowerCase());
          });
        }

        // Filter berdasarkan keyword
        data = data.filter((policy) => {
          return (
            policy.title.toLowerCase().includes(this.keyword.toLowerCase()) ||
            (policy.sk_number && policy.sk_number.toLowerCase().includes(this.keyword.toLowerCase())) ||
            policy.category?.name.toLowerCase().includes(this.keyword.toLowerCase())
          );
        });

        // Sorting
        data = this.sortPolicies(data);

        return data;
      },
      splittedPolicies() {
        return this.filteredPolicies.slice(
          (this.pageNumber - 1) * this.perPage,
          this.pageNumber * this.perPage
        );
      },
      totalPage() {
        return Math.ceil(this.filteredPolicies.length / this.perPage);
      },
      filteredType() {
        return this.policies.filter((el) => el.category?.name === this.filter);
      },
    },
    methods: {
      ...mapActions(["fetchAllPolicy"]),
      sortPolicies(data) {
        let sortedData = [...data];
        
        if (this.sortBy === "terbaru") {
          sortedData.sort((a, b) => {
            const yearA = this.extractYear(a.sk_number);
            const yearB = this.extractYear(b.sk_number);
            return yearB - yearA;
          });
        } else if (this.sortBy === "terlama") {
          sortedData.sort((a, b) => {
            const yearA = this.extractYear(a.sk_number);
            const yearB = this.extractYear(b.sk_number);
            return yearA - yearB;
          });
        } else if (this.sortBy === "a-z") {
          sortedData.sort((a, b) => 
            a.title.localeCompare(b.title, 'id')
          );
        } else if (this.sortBy === "z-a") {
          sortedData.sort((a, b) => 
            b.title.localeCompare(a.title, 'id')
          );
        }
        
        return sortedData;
      },
      extractYear(skNumber) {
        if (!skNumber) return 0;
        const parts = skNumber.split('/');
        if (parts.length > 1) {
          const yearMatch = parts[1].match(/\d{4}/);
          if (yearMatch) {
            return parseInt(yearMatch[0]);
          }
        }
        return 0;
      },
      show(data) {
        // let url = $(this).attr("data-url");

        $("#embed").attr("src", data);
        $("#modal").modal("show");

        return false;
      },
      onChangePage(page) {
        this.pageNumber = page;
      },
    },
    created() {
      this.fetchAllPolicy();
    },
  };
  </script>
  